export enum CompanyRole {
  ADMIN = 'Admin',
  COMPANY_MANAGER = 'Company manager',
  LOCATION_MANAGER = 'Store/location manager',
  HR_MANAGER = 'HR manager',
  EMPLOYEE = 'Employee',
  ACCOUNT_MANAGER = 'Account manager',
}
